import React, { ReactNode } from 'react';

const ContentContainer = ({ children }: { children: ReactNode }) => {
  return <div className='p-4'>{children}</div>;
};

export default ContentContainer;
